(function () {
'use strict';

angular.module('hyresgastApp').controller('EditAgreementApartmentCtrl', EditAgreementApartmentCtrl);

function EditAgreementApartmentCtrl(
  $scope, $location, $route, $routeParams, $document,
  Agreement, Negotiation,
  Flash, ErrorHandler,
  FPConsts, CommonIds, Limits) {
  var vm = this;

  vm.Limits = Limits;
  vm.validStatuses = FPConsts.apartmentStatusesForNegotation;

  vm.agreement = {
    negotiationId: $routeParams.negotiationId,
    id: $routeParams.id,
    documents: [],
    name: '', // there is a not null constraing on api
    isAllDistrictsSelected: true,
    isAllPropertiesSelected: true,
    isAllApartmentsSelected: true
  };

  vm.listPropertiesColumns = [
    { title: 'Fastigheter', column: 'propertyDesignation' },
    { title: 'Kommun', column: 'municipality' },
    { title: 'LM distrikt', column: 'district' },
    { title: 'Antal lägenheter', column: 'numNegotiatedApartments', filterType: 'none' },
    { title: 'Fastighetsägare', column: 'owners', type: 'array' }
  ];
  vm.listApartmentsColumns = [
    { title: 'Nationellt lägenhetsnr', column: 'nationalNo' },
    { title: 'Lägenhetsnr', column: 'ownerNo' },
    { title: 'Gatuadress', column: 'streetAddress' },
    { title: 'Yta', column: 'livingSpace' },
    { title: 'Antal Rum', column: 'rooms' },
    { title: 'Aktuell hyra (kr/månad)', column: 'currentMonthlyRent', template: 'hyra' },
    { title: 'Fastighet', column: 'property.propertyDesignation' },
    { title: 'Kommun', column: 'municipality' },
    { title: 'LM distrikt', column: 'district' },
    {
      title: 'Status',
      column: 'status',
      template: 'status',
      lookup: {
        idProperty: 'code',
        textProperty: 'longName',
        dictionary: vm.validStatuses,
      },
      ffn: (value, filter) => [(value & filter.code), CommonIds.tableauAllId].includes(filter.code),
    },
    { title: 'Komment', column: 'comment', template: 'comment', filterType: 'none' },
  ];

  vm.gotoNextStep = () => { vm.gotoNext = true }
  vm.save = save;

  vm.propertiesPageLimit = 30;
  vm.apartmentsPageLimit = 30;

  let refreshTableau = id => angular.element($document[0].querySelector("#"+id)).scope().$broadcast('refresh');

  $scope.$on('$routeUpdate', function() {
    if ($location.search().step === 'apartments') {
      refreshTableau('tableauApartments');
    }
  });

  ////////////
  getNegotiation();

  function getNegotiation() {
    return Negotiation.get({
      id: $routeParams.negotiationId
    })
      .$promise.then(function(response) {
        vm.negotiation = response;
      })
      .catch(ErrorHandler('Misslyckades att hämta förhandling.'))
      .finally(function() {
        vm.readyNegotiation = true;
      });
  }

  vm.fGetProperties = () => {
    // eslint-disable-next-line no-undef
    return new Promise(resolve => {
      Negotiation.queryPropertyBySelection({ id: $routeParams.negotiationId }, {
        unassigned: true,
        selectedDistrictIds: vm.agreement.selectedDistrictIds,
        isAllDistrictsSelected: true
      }).$promise.then(function(response) {
        vm.properties = response.rows;
        resolve(response);
      }).catch(ErrorHandler('Misslyckades att hämta fastigheter.'))
    });
  };

  let packEntity = (selectedArray, array) => {
    let selectedIds = array.reduce((acc, el) => {
      acc[el.id] = selectedArray.some(x => x.id === el.id);
      return acc;
    }, {});
    let isAllSelected = array.length === selectedArray.length;
    return { selectedIds, isAllSelected };
  };

  vm.fGetApartments = () => {
    // eslint-disable-next-line no-undef
    return new Promise(resolve => {
      if ($location.search().step !== 'apartments') {
        resolve({ rows: [], count: 0 });
        return;
      }
      let pack = packEntity(vm.selectedProperties, vm.properties);
      Negotiation.queryApartment({
        id: $routeParams.negotiationId,
        unassigned: true
      }, {
        isAllDistrictsSelected: true,
        selectedPropertyIds: pack.selectedIds,
        isAllPropertiesSelected: pack.isAllSelected,
      }).$promise.then(function(response) {
        vm.apartments = response.rows;
        resolve(response);
      }).catch(ErrorHandler('Misslyckades att hämta lägenheter.'));
    });
  };

  function save() {
    vm.saving = true;
    let pack = packEntity(vm.selectedApartments, vm.apartments);
    let payload = Object.assign(vm.agreement, {
      isAllApartmentsSelected: false,
      selectedApartmentIds: pack.selectedIds,
    });
    // eslint-disable-next-line no-unused-vars
    Agreement.saveApartment(payload).$promise.then(response => {
      $route.reload();
      Flash.set('Fastighetsbestånd har sparats', 'success');
    }).catch(ErrorHandler('Misslyckades att spara fastighetsbestånd.'))
      .finally(() => {
        vm.saving = false;
        $location.search({});
        $location.path('/negotiations/' + $routeParams.negotiationId + '/agreements/' + $routeParams.id);
      });
  }
}
})();